import React from "react";

import logoImage from "../../images/Kid Logo.png";
import { FaUser } from "react-icons/fa";
import "./Navbar.css";

import { Link, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { NavLink } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();
  return (
    <div className="navbar-wrapper">
      <div className="main-nav">
        <div className="logo">
          <img
            src={logoImage}
            alt="KidsChoice Logo"
            className="logo-image"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div>
          <Button
            style={{
              height: "2rem",
              marginLeft: "10px",
              // color: "blue",
            }}
            label="Home"
            size="small"
            text
            rounded
            severity="info"
            onClick={() => navigate("/")}></Button>{" "}
          <Button
            style={{ height: "2rem", marginLeft: "10px" }}
            label="Contact us"
            size="small"
            text
            rounded
            severity="info"
            onClick={() => navigate("/contact")}></Button>
          <Button
            // className="ml-2"
            style={{ height: "2rem", marginLeft: "10px" }}
            size="small"
            label=" About us"
            rounded
            onClick={() => navigate("/AboutUs")}
            text
            severity="info"></Button>
          <Button
            className="icon"
            icon={<FaUser />}
            onClick={() => navigate("/LoginPage")}
            style={{ cursor: "pointer" }}
            text
            security="secondary"
          />
        </div>
      </div>
    </div>
  );
}

export default Navbar;

// import React, { useState } from "react";
// import logoImage from "../../images/Kid Logo.png";
// import { FaUser, FaBars } from "react-icons/fa";
// import "./Navbar.css";

// import { useNavigate } from "react-router-dom";
// import { Button } from "primereact/button";
// import { InputText } from "primereact/inputtext";

// function Navbar() {
//   const navigate = useNavigate();
//   const [menuOpen, setMenuOpen] = useState(false);

//   return (
//     <div className="navbar-wrapper">
//       <div className="main-nav">
//         {/* Logo Section */}
//         <div className="logo">
//           <img src={logoImage} alt="KidsChoice Logo" className="logo-image" />
//         </div>

//         {/* Hamburger icon on small screen */}
//         <div className="hamburger-icon" onClick={() => setMenuOpen(!menuOpen)}>
//           <FaBars />
//         </div>

//         {/* Buttons & Search Section */}
//         <div className={`navbar-controls ${menuOpen ? "show" : ""}`}>
//           <div className="search-box">
//             <InputText type="text" placeholder="Search" />
//           </div>
//           <Button
//             className="navbar-btn"
//             label="Contact us"
//             size="small"
//             rounded
//             onClick={() => navigate("/contact")}
//           />
//           <Button
//             className="navbar-btn"
//             label="About us"
//             size="small"
//             rounded
//             onClick={() => navigate("/AboutUs")}
//           />
//           <Button
//             className="navbar-btn"
//             icon={<FaUser />}
//             onClick={() => navigate("/LoginPage")}
//             text
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Navbar;
